// These functions exist to lift the "unsafe" direct access globals out of the main
// index.ts, so it can be a happy TypeScript file, without totally refactoring
// everything to have the global config stuff made available in another way.

export function pageConfigContentId() {
  return window.PAGE_CONFIG?.content_id
}

export function tcConfigUserEventCollectorUrl() {
  return window.TC?.Config?.user_event_collector_url || ""
}

export function didomiIsEnabled() {
  return window?.DIDOMI?.ENABLED
}
